import { mediaQueries } from '../../styles/media-queries';
import { pxToRem } from '../../styles/utils';
import styled from '../../theme/styled-with-theme';

import { Flexbox } from '../Flexbox';
import { Button } from '../Button';
import Link from '../Link';

export const WEB_BANNER_HEIGHT = 64;

export const WebBannerWrapper = styled(Flexbox)`
  width: 90vw;
  margin: auto;
  height: ${pxToRem(WEB_BANNER_HEIGHT)};

  ${mediaQueries.max} {
    width: 85vw;
  }
`;

export const WebBannerCloseButton = styled(Button)`
  @media (hover: hover) {
    &:hover,
    &:focus {
      background-color: #353a41;
      color: #ffffff;
    }
  }

  ${mediaQueries[0]} {
    max-width: ${pxToRem(32)};
    min-width: ${pxToRem(32)};
    width: ${pxToRem(32)};
    height: ${pxToRem(32)};
    background-color: #353a41;
    border-radius: ${({ theme }) => theme.borderRadius.input_button};
    padding: 0px;
    line-height: 0px;
  }

  ${mediaQueries.min} {
    max-width: ${pxToRem(32)};
    min-width: ${pxToRem(32)};
    width: ${pxToRem(32)};
    height: ${pxToRem(32)};
    background-color: #353a41;
    border-radius: ${({ theme }) => theme.borderRadius.input_button};
    padding: 0px;
    line-height: 0px;
  }

  ${mediaQueries.desktop} {
    max-width: ${pxToRem(32)};
    min-width: ${pxToRem(32)};
    width: ${pxToRem(32)};
    height: ${pxToRem(32)};
    background-color: #353a41;
    border-radius: ${({ theme }) => theme.borderRadius.input_button};
    padding: 0px;
    line-height: 0px;
  }
`;

export const WebBannerButtonRight = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'bgColor'
})<{ bgColor?: string }>`
  background-color: ${({ bgColor }) => bgColor};

  ${mediaQueries[0]} {
    display: none;
  }

  ${mediaQueries.min} {
    display: none;
  }

  ${mediaQueries.desktop} {
    background-color: #353a41;
    border-radius: 0px 0px ${pxToRem(24)} 0px;
    height: 100%;
    font-size: ${({ theme }) => theme.fontSize.sm};
    align-items: center;
    flex-direction: row;
    display: flex;
    justify-content: space-evenly;
  }

  @media (hover: hover) {
    &:hover,
    &:focus {
      background-color: #353a41;
      color: #ffffff;
    }
  }
`;

export const WebBannerButtonArrowOnly = styled(Button)`
  ${mediaQueries[0]} {
    max-width: ${pxToRem(56)};
    min-width: ${pxToRem(56)};
    width: ${pxToRem(56)};
    height: ${pxToRem(56)};
    background-color: #353a41;
    border-radius: 0px 0px ${pxToRem(24)} 0px;
    height: 100%;
    font-size: ${pxToRem(16)};
    align-items: center;
    flex-direction: row;
    display: flex;
    justify-content: space-evenly;
  }

  ${mediaQueries.min} {
    max-width: ${pxToRem(56)};
    min-width: ${pxToRem(56)};
    width: ${pxToRem(56)};
    height: ${pxToRem(56)};
    background-color: #353a41;
    border-radius: 0px 0px ${pxToRem(24)} 0px;
    height: 100%;
    font-size: ${pxToRem(16)};
    align-items: center;
    flex-direction: row;
    display: flex;
    justify-content: space-evenly;
  }

  ${mediaQueries.desktop} {
    display: none;
  }

  @media (hover: hover) {
    &:hover,
    &:focus {
      background-color: #353a41;
      color: #ffffff;
    }
  }
`;

export const InlineAnchor = styled(Link)`
  color: #00c9a7;
  font-weight: ${({ theme }) => theme.fontWeight.p};
  font-style: underline;
  transition: 0.2s color ease;
  white-space: nowrap;

  &:hover {
    color: ${({ theme }) => theme.color.darkButton};
  }
`;

export const CTALinkButtonRight = styled(Link)`
  text-decoration: none;

  ${mediaQueries[0]} {
    display: none;
  }

  ${mediaQueries.min} {
    display: none;
  }

  ${mediaQueries.desktop} {
    display: flex;
  }
`;

export const CTALinkButtonOnly = styled(Link)`
  text-decoration: none;

  ${mediaQueries[0]} {
    display: flex;
  }

  ${mediaQueries.min} {
    display: flex;
  }

  ${mediaQueries.desktop} {
    display: none;
  }
`;
